export { default } from './CDCProtegido25Informacoes';
